import React from 'react';
import {observer} from "mobx-react";
import {ShotMapGoalViewBall} from "./shot-map.goal-view.ball";

export const ShotMapGoalViewShots = observer(({game, events, onChange}) => {
  const shouldAddKey = events?.length > 1; //for animation use
  return events.map((event) => <ShotMapGoalViewBall
    key={shouldAddKey ? event.key : null}
    event={event}
    game={game}
    onChange={onChange}/>)
})
